<template>
  <header class="header-entry">
    <div class="container">
      <div class="logo">
        <img
          src="@/assets/images/common/logo_main.gif"
          :alt="$t('common.sitename')"
          class="img-fluid"
        />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderEntry",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.header-entry {
  padding-bottom: 20px;
  border-bottom: 1px solid #ccc;
  margin-top: 15px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  @include mq-up(md) {
    margin-top: 30px;
    padding-bottom: 20px;
  }
  .logo {
    max-width: 93px;
    @include mq-up(md) {
      max-width: 186px;
    }
  }
}
</style>
